import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SourceView } from "@/plugins/search/source-view";

export const Route = createFileRoute("/_authed/sources/$id")({
  // `quote`: the words the citations of this passage quote, each marked in it.
  validateSearch: z.object({ quote: z.array(z.string()).optional() }),
  component: Source,
});

function Source() {
  const { id } = Route.useParams();
  const { quote } = Route.useSearch();
  return <SourceView id={id} quotes={quote ?? []} />;
}
